import { SubscriptionManager } from '@/components/subscription-manager';
import { useAuth } from '@/hooks/use-auth';

export default function SubscriptionPage(): import('react/jsx-runtime').JSX.Element {
  const { user } = useAuth();

  const userId = user?.id ?? '';
  const email = user?.email ?? '';

  return (
    <div className="mx-auto max-w-6xl px-4 py-6 space-y-6">
      <div>
        <h1 className="text-lg font-semibold">Subscription</h1>
        <p className="text-xs text-muted-foreground mt-0.5">Manage your plan and billing</p>
      </div>
      <SubscriptionManager userId={userId} email={email} />
    </div>
  );
}
